export default function Index() {
  return (
    <section style={{ display: "grid", gap: 18 }}>
      <div className="card">
        <div className="card-body" style={{ display: "grid", gap: 6 }}>
          <h1 style={{ margin: 0, letterSpacing: "-0.02em" }}>Attorney Forms Builder</h1>
          <p className="muted">Build and manage forms with secure access controls</p>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 4 }}>
            <a className="btn" href="/forms/demo/intake/builder">Try Form Builder</a>
            <a className="btn ghost" href="/forms/demo/intake/responses">View Responses</a>
            <a className="btn ghost" href="/portals/demo/client-portal/preview">Preview Portal</a>
            <a className="btn ghost" href="/portals/demo/client-portal/edit">Edit Portal</a>
          </div>
        </div>
      </div>

      <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}>
        <article className="card"><div className="card-body"><strong>📝 Form Builder</strong><p className="muted">Intuitive JSON editor with live preview.</p></div></article>
        <article className="card"><div className="card-body"><strong>📊 Response Viewer</strong><p className="muted">Filter and paginate submissions.</p></div></article>
        <article className="card"><div className="card-body"><strong>🧰 Portals</strong><p className="muted">Preview and edit portal configuration.</p></div></article>
      </div>
    </section>
  );
}
